import { STATE_CODE_TO_NAME } from 'src/constants/community'

export class CommunityUtils {
  static getNameByCode(code?: string) {
    return STATE_CODE_TO_NAME?.find((item) => item.code.toLowerCase() === code?.toLowerCase())?.name
  }
}
